import { render, staticRenderFns } from "./language-items.vue?vue&type=template&id=f0b5d476&scoped=true&"
import script from "./language-items.vue?vue&type=script&lang=js&"
export * from "./language-items.vue?vue&type=script&lang=js&"
import style0 from "./language-items.vue?vue&type=style&index=0&id=f0b5d476&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b5d476",
  null
  
)

export default component.exports